module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAKCAYAAABWiWWfAAAAAXNSR0IArs4c6QAAAG5JREFUKBVjYCAR/P//nxGIZwAxF4lasSsHGqQAxPOAmBO7ChJFoQbOAdIcJGrFrhxq4EwgzQ5SAfK/PJCmxLmKQP3xIMwCJOyAmBeIyQU8QI0mQCxIrgFgfUBf8QDxCiBWG2YGgbwD9NZUbF4DANWgT5iYlZ/3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/left.png
// module id = 8AFt
// module chunks = 1